import {
  useBulkAddGoodProfilesMutation,
  useGetGoodProfileListQuery,
} from "../../../graphql/generated";
import GoodProfilesList from "./GoodProfilesList";

const useGoodProfilesIncludingInactive: Parameters<typeof GoodProfilesList>[0]["query"] = (
  variables,
  options
) =>
  useGetGoodProfileListQuery(
    { ...variables, includeInactive: true },
    options
  );

export default function GoodProfilesListContainer() {
  const bulkCreateGoodProfiles = useBulkAddGoodProfilesMutation();
  return (
    <GoodProfilesList
      onBulkCreate={(goodProfiles) =>
        bulkCreateGoodProfiles.mutateAsync({
          newGoodProfilesData: goodProfiles,
        })
      }
      query={useGoodProfilesIncludingInactive}
    />
  );
}
